import { render, staticRenderFns } from "./formDesign.vue?vue&type=template&id=5c68f126&scoped=true&"
import script from "./formDesign.vue?vue&type=script&lang=ts&"
export * from "./formDesign.vue?vue&type=script&lang=ts&"
import style0 from "./formDesign.vue?vue&type=style&index=0&id=5c68f126&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68f126",
  null
  
)

export default component.exports